// extracted by mini-css-extract-plugin
module.exports =  {"fixed":"fixed--l3yod"};